import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function PublicOffersTest() {
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  // 🔁 Récupère toutes les offres dès que la page est chargée
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_DOMAINE}/api/jobs`);
        setJobs(res.data);
      } catch (err) {
        console.error("Erreur récupération des offres :", err.message);
      }
    };

    fetchJobs();
  }, []);

  return (
    <div className="container mt-4">
      <h2>📋 Offres disponibles (vue de test)</h2>

      {jobs.length === 0 ? (
        <p>Aucune offre trouvée.</p>
      ) : (
        <div className="row">
          {jobs.map((job) => (
            <div key={job.id} className="col-md-6">
              <div className="card mb-3 shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{job.title}</h5>
                  <p className="card-text"><strong>Contrat :</strong> {job.type_contrat}</p>
                  <p className="card-text"><strong>Salaire :</strong> {job.budget} €</p>
                  <p className="card-text"><strong>Déscription :</strong> <br />{job.description}</p>
                  <p className="card-text"><strong>Lieu :</strong> {job.ville}, {job.pays}</p>
                  <p className="card-text"><strong>Filiale :</strong> {job.filiale}</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => navigate(`/postuler/${job.id}`)}
                  >
                    Postuler
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PublicOffersTest;
